import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

//
import { Card } from "react-bootstrap";
import Moment from "react-moment";

//
import { iconImage, getTops } from "../../redux/features/coins/actions";

//
import BoxLoading from "../general/BoxLoading";
import ImageBox from "../general/ImageBox";

function TopFive({ title, type, limit, dashboard = false, heatmap = false }) {
  const [items, setItems] = useState([]);
  const [time, setTime] = useState("");
  //
  const [loading, setLoading] = useState(false);

  /**
   * Get Tops
   */
  const get_tops = async () => {
    setLoading(true);

    await getTops({ type, limit }).then((res) => {
      if (res) {
        setItems(res.items);
        setTime(res.time);
      }
    });

    setLoading(false);
  };

  useEffect(() => {
    get_tops();
    // eslint-disable-next-line
  }, []);

  return (
    <Card className="top-five h-100">
      <Card.Header className="flex-wrap">
        {title}
        <small>
          Updated in
          <span>
            <Moment utc unix format="h:mm:ss">
              {time}
            </Moment>
            {" "}(UTC)
          </span>
        </small>
      </Card.Header>
      <Card.Body>
        {items.map((item, index) => (
          <div className="item" key={index}>
            <div className="info">
              <span className="index">#{index + 1}</span>

              <ImageBox src={iconImage(item.symbol)} />

              <Link
                to={`/app/coin-detail/${item.symbol}`}
                className="d-flex align-items-baseline"
              >
                <span className="name">
                  {dashboard ? <h5>{item.name}</h5> : <>{item.name}</>}
                </span>
                {dashboard && <span className="symbol">({item.symbol})</span>}
              </Link>
            </div>

            {heatmap ? (
              <div className="percent-container">
                <div
                  className={`percent-item ${
                    +item.profit >= 0 ? "active" : ""
                  }`}
                ></div>
                <div
                  className={`percent-item ${
                    +item.profit > 25 ? "active" : ""
                  }`}
                ></div>
                <div
                  className={`percent-item ${
                    +item.profit > 50 ? "active" : ""
                  }`}
                ></div>
                <div
                  className={`percent-item ${
                    +item.profit > 75 ? "active" : ""
                  }`}
                ></div>
              </div>
            ) : (
              <p
                className={`percent ${
                  +item.profit > 0 ? "text-success" : "text-danger"
                }`}
              >
                {item.profit}%{" "}
                <i
                  className={`las la-arrow-${
                    +item.profit > 0 ? "up" : "right"
                  }`}
                />
              </p>
            )}
          </div>
        ))}
      </Card.Body>

      {loading && <BoxLoading />}
    </Card>
  );
}

TopFive.propTypes = {
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  limit: PropTypes.string.isRequired,
  dashboard: PropTypes.bool,
  heatmap: PropTypes.bool,
};

export default TopFive;
